export default __webpack_public_path__ + "static/media/bg10.2b2733c7.jpg";